import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withKeys as _withKeys, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "blue_box _full" }
const _hoisted_3 = { class: "sch_condition_wrap" }
const _hoisted_4 = { class: "left _column _flex" }
const _hoisted_5 = { class: "checkbox_wrap sch_list" }
const _hoisted_6 = { for: "chk_all" }
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  class: "_flex _align_bottom _multi",
  style: {"z-index":"3"}
}
const _hoisted_9 = { class: "select_tab_box_wrap" }
const _hoisted_10 = { class: "select_tab_box _130" }
const _hoisted_11 = { class: "tab_option" }
const _hoisted_12 = { class: "select_tab_box_wrap" }
const _hoisted_13 = { class: "select_tab_box _130" }
const _hoisted_14 = { class: "tab_option" }
const _hoisted_15 = { class: "select_date_wrap" }
const _hoisted_16 = { class: "select_date" }
const _hoisted_17 = { class: "select_date" }
const _hoisted_18 = { class: "sch_condition_wrap" }
const _hoisted_19 = { class: "left _column _flex" }
const _hoisted_20 = { class: "_flex _align_bottom _multi" }
const _hoisted_21 = { class: "select_tab_box_wrap" }
const _hoisted_22 = { class: "select_search_row" }
const _hoisted_23 = { class: "select_tab_box _230" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "search_wrap" }
const _hoisted_26 = { class: "right _align_bottom _flex" }
const _hoisted_27 = { type: "button" }
const _hoisted_28 = { class: "common_table custom_scroll" }
const _hoisted_29 = { class: "checkbox_wrap cnt p_5 checkbox_wrap2" }
const _hoisted_30 = { class: "checkbox_wrap cnt p_5 checkbox_wrap2" }
const _hoisted_31 = ["for"]
const _hoisted_32 = ["id", "value"]
const _hoisted_33 = { class: "list_num" }
const _hoisted_34 = ["href"]
const _hoisted_35 = { class: "underline" }
const _hoisted_36 = ["href"]
const _hoisted_37 = { class: "cnt p_5" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "cnt" }
const _hoisted_41 = {
  key: 2,
  class: "cnt"
}
const _hoisted_42 = {
  key: 3,
  class: "cnt"
}
const _hoisted_43 = { key: 4 }
const _hoisted_44 = { key: 5 }
const _hoisted_45 = { class: "cnt" }
const _hoisted_46 = { class: "cnt p_5" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Left = _resolveComponent("Left")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_ReportModal = _resolveComponent("ReportModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Left),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[53] || (_cache[53] = _createElementVNode("div", { class: "box_tit _flex" }, [
          _createElementVNode("h2", null, "시민제보창")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  id: "chk_all",
                  type: "radio",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.type) = $event)),
                  value: 0,
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.toggleAllRole && $setup.toggleAllRole(...args))),
                  checked: ""
                }, null, 544), [
                  [_vModelRadio, $setup.state.type]
                ]),
                _cache[34] || (_cache[34] = _createElementVNode("em", null, null, -1)),
                _cache[35] || (_cache[35] = _createElementVNode("span", null, "전체", -1))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.typeList, (item) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: item.key
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    value: item.key,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.type) = $event)),
                    onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.handleRoleChange && $setup.handleRoleChange(...args)))
                  }, null, 40, _hoisted_7), [
                    [_vModelRadio, $setup.state.type]
                  ]),
                  _cache[36] || (_cache[36] = _createElementVNode("em", null, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(item.value), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[37] || (_cache[37] = _createElementVNode("span", { class: "sch_list_tit" }, "상태값", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["selected_tab", { active: $setup.state.isShowStateType }]),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.state.isShowStateType = !$setup.state.isShowStateType))
                  }, [
                    _createElementVNode("span", null, _toDisplayString($setup.state.detailStateTxt), 1)
                  ], 2),
                  _withDirectives(_createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => {
                                            $setup.state.state = 0;
                                            $setup.state.detailStateTxt = '전체';
                                            $setup.state.isShowStateType = false;
                                            $setup.state.page = 1;
                                            $setup.getList();
                                        })
                    }, " 전체 "),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => {
                                            $setup.state.state = 1;
                                            $setup.state.detailStateTxt = '대기중';
                                            $setup.state.isShowStateType = false;
                                            $setup.state.page = 1;
                                            $setup.getList();
                                        })
                    }, " 대기중 "),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => {
                                            $setup.state.state = 2;
                                            $setup.state.detailStateTxt = '접수완료';
                                            $setup.state.isShowStateType = false;
                                            $setup.state.page = 1;
                                            $setup.getList();
                                        })
                    }, " 접수완료 ")
                  ], 512), [
                    [_vShow, $setup.state.isShowStateType]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[38] || (_cache[38] = _createElementVNode("span", { class: "sch_list_tit" }, "조치", -1)),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["selected_tab", { active: $setup.state.isShowIsReportType }]),
                    onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.state.isShowIsReportType = !$setup.state.isShowIsReportType))
                  }, [
                    _createElementVNode("span", null, _toDisplayString($setup.state.detailIsReportTxt), 1)
                  ], 2),
                  _withDirectives(_createElementVNode("div", _hoisted_14, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => {
                                            $setup.state.isReport = 0;
                                            $setup.state.reportState = 0;
                                            $setup.state.detailIsReportTxt = '전체';
                                            $setup.state.isShowIsReportType = false;
                                            $setup.state.page = 1;
                                            $setup.getList();
                                        })
                    }, " 전체 "),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => {
                                            $setup.state.isReport = 1;
                                            $setup.state.reportState = 1;
                                            $setup.state.detailIsReportTxt = '가능';
                                            $setup.state.isShowIsReportType = false;
                                            $setup.state.page = 1;
                                            $setup.getList();
                                        })
                    }, " 신고 가능 "),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => {
                                            $setup.state.isReport = 1;
                                            $setup.state.reportState = 2;
                                            $setup.state.detailIsReportTxt = '가능';
                                            $setup.state.isShowIsReportType = false;
                                            $setup.state.page = 1;
                                            $setup.getList();
                                        })
                    }, " 고발 가능 "),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => {
                                            $setup.state.isReport = 2;
                                            $setup.state.reportState = 0;
                                            $setup.state.detailIsReportTxt = '불가능';
                                            $setup.state.isShowIsReportType = false;
                                            $setup.state.page = 1;
                                            $setup.getList();
                                        })
                    }, " 불가능 ")
                  ], 512), [
                    [_vShow, $setup.state.isShowIsReportType]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    onKeydown: _cache[13] || (_cache[13] = _withKeys(
//@ts-ignore
(...args) => ($setup.searchDate && $setup.searchDate(...args)), ["enter"])),
                    name: "",
                    id: "",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.form_state.startDate) = $event)),
                    onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => ($setup.getList && $setup.getList(...args)))
                  }, null, 544), [
                    [_vModelText, $setup.form_state.startDate]
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("input", {
                    style: {"margin-left":"5px"},
                    type: "date",
                    onKeydown: _cache[16] || (_cache[16] = _withKeys(
//@ts-ignore
(...args) => ($setup.searchDate && $setup.searchDate(...args)), ["enter"])),
                    name: "",
                    id: "",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.form_state.endDate) = $event)),
                    onChange: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => ($setup.getList && $setup.getList(...args)))
                  }, null, 544), [
                    [_vModelText, $setup.form_state.endDate]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[40] || (_cache[40] = _createElementVNode("span", { class: "sch_list_tit" }, "업종분류", -1)),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["selected_tab", { active: $setup.state.isShowCategoryType }]),
                      onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.state.isShowCategoryType = !$setup.state.isShowCategoryType))
                    }, [
                      _createElementVNode("span", null, _toDisplayString($setup.state.detailTxt), 1)
                    ], 2),
                    _withDirectives(_createElementVNode("div", {
                      class: _normalizeClass(["tab_option", { active: $setup.state.isShowCategoryType }])
                    }, [
                      _createElementVNode("button", {
                        onClick: _cache[20] || (_cache[20] = ($event: any) => {
                                                $setup.state.categoryType = 0;
                                                $setup.state.detailTxt = '전체';
                                                $setup.state.isShowCategoryType = false;
                                                $setup.state.page = 1;
                                                $setup.getList();
                                            })
                      }, " 전체 "),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.categoryList, (item) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: item.caIdx,
                          onClick: ($event: any) => {
                                                $setup.state.categoryType = item.caIdx;
                                                $setup.state.detailTxt = item.caName;
                                                $setup.state.isShowCategoryType = false;
                                                $setup.state.page = 1;
                                                $setup.getList();
                                            }
                        }, _toDisplayString(item.caName), 9, _hoisted_24))
                      }), 128))
                    ], 2), [
                      [_vShow, $setup.state.isShowCategoryType]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.state.searchText) = $event)),
                      onKeyup: _cache[22] || (_cache[22] = _withKeys(
//@ts-ignore
(...args) => ($setup.searchText && $setup.searchText(...args)), ["enter"])),
                      placeholder: "업소명을 입력하세요."
                    }, null, 544), [
                      [_vModelText, $setup.state.searchText]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "search_btn icon_wrap",
                      onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => ($setup.searchText && $setup.searchText(...args)))
                    }, [...(_cache[39] || (_cache[39] = [
                      _createElementVNode("img", {
                        src: "img/search_btn.png",
                        alt: ""
                      }, null, -1)
                    ]))])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              type: "button",
              class: "default_btn _gray",
              onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => ($setup.isDelete && $setup.isDelete(...args)))
            }, "삭제"),
            _createElementVNode("button", _hoisted_27, [
              _createElementVNode("img", {
                src: "img/excel_icon.png",
                alt: " 엑셀 다운로드",
                onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => ($setup.downloadFile && $setup.downloadFile(...args)))
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("table", null, [
            _cache[52] || (_cache[52] = _createElementVNode("colgroup", null, [
              _createElementVNode("col", { style: {"width":"40px"} }),
              _createElementVNode("col", { style: {"width":"80px"} }),
              _createElementVNode("col", { style: {"width":"180px"} }),
              _createElementVNode("col"),
              _createElementVNode("col", { style: {"width":"170px"} }),
              _createElementVNode("col", { style: {"width":"170px"} }),
              _createElementVNode("col", { style: {"width":"120px"} }),
              _createElementVNode("col", { style: {"width":"120px"} }),
              _createElementVNode("col", { style: {"width":"170px"} }),
              _createElementVNode("col", { style: {"width":"60px"} }),
              _createElementVNode("col", { style: {"width":"60px"} })
            ], -1)),
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.state.checkAll) = $event)),
                    onChange: _cache[27] || (_cache[27] = ($event: any) => ($setup.toggleAll()))
                  }, null, 544), [
                    [_vModelCheckbox, $setup.state.checkAll]
                  ])
                ]),
                _cache[41] || (_cache[41] = _createElementVNode("th", null, "번호", -1)),
                _cache[42] || (_cache[42] = _createElementVNode("th", null, "게시판 이름", -1)),
                _cache[43] || (_cache[43] = _createElementVNode("th", null, "업소명", -1)),
                _cache[44] || (_cache[44] = _createElementVNode("th", null, "작성일", -1)),
                _cache[45] || (_cache[45] = _createElementVNode("th", null, "분류", -1)),
                _cache[46] || (_cache[46] = _createElementVNode("th", null, "상태값", -1)),
                _cache[47] || (_cache[47] = _createElementVNode("th", null, "조치", -1)),
                _cache[48] || (_cache[48] = _createElementVNode("th", null, "불가능 사유", -1)),
                _cache[49] || (_cache[49] = _createElementVNode("th", null, "메모", -1)),
                _cache[50] || (_cache[50] = _createElementVNode("th", null, "수정", -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              ($setup.state.list.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item, idx) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.idx
                    }, [
                      _createElementVNode("td", _hoisted_30, [
                        _createElementVNode("label", {
                          for: 'chk_main' + item.idx,
                          onClick: _cache[30] || (_cache[30] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: 'chk_main' + item.idx,
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.state.checkedList) = $event)),
                            value: item.idx,
                            onClick: _cache[29] || (_cache[29] = _withModifiers(() => {}, ["stop"]))
                          }, null, 8, _hoisted_32), [
                            [_vModelCheckbox, $setup.state.checkedList]
                          ])
                        ], 8, _hoisted_31)
                      ]),
                      _createElementVNode("td", _hoisted_33, _toDisplayString(($setup.state.page - 1) * $setup.state.size + (idx + 1)), 1),
                      _createElementVNode("td", {
                        class: _normalizeClass(["underline", [item.type == 1 ? 'blue_tag' : 'green_tag']])
                      }, [
                        _createElementVNode("a", {
                          href: 
                                            $setup.state.userSiteUrl + '/#/' + (item.type === 1 ? 'report?type=' + item.type : 'report?type=' + item.type)
                                        ,
                          target: "_blank"
                        }, _toDisplayString(item.type === 1 ? "성매매 의심 업소 제보" : "성매매 알선 광고 제보"), 9, _hoisted_34)
                      ], 2),
                      _createElementVNode("td", _hoisted_35, [
                        _createElementVNode("a", {
                          href: $setup.state.userSiteUrl + '/#/' + (item.type === 1 ? 'areaView/' : 'adView/') + item.idx,
                          target: "_blank"
                        }, _toDisplayString(item.shopName), 9, _hoisted_36)
                      ]),
                      _createElementVNode("td", _hoisted_37, _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.createDate), ".", true)), 1),
                      (item.type == 1)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_38, _toDisplayString(item.isSchool == 1 ? "학교주변" : "학교주변 외"), 1))
                        : (_openBlock(), _createElementBlock("td", _hoisted_39, _toDisplayString($setup.strAdType(item.adType)), 1)),
                      _createElementVNode("td", _hoisted_40, _toDisplayString(item.state == 1 ? "대기중" : "접수완료"), 1),
                      (item.isReport != null)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_41, _toDisplayString(item.isReport == 1 ? (item.reportState === 1 ? "신고가능" : "고발가능") : "불가능"), 1))
                        : (_openBlock(), _createElementBlock("td", _hoisted_42, "대기중")),
                      (item.isReport == 2)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_43, _toDisplayString($setup.strReason(item.reason)), 1))
                        : (_openBlock(), _createElementBlock("td", _hoisted_44, "-")),
                      _createElementVNode("td", _hoisted_45, _toDisplayString(item.memo ? "O" : "-"), 1),
                      _createElementVNode("td", _hoisted_46, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "table_btn _blue",
                          onClick: ($event: any) => ($setup.modifyModal(item.type, item.idx))
                        }, "수정", 8, _hoisted_47)
                      ])
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("tr", _hoisted_48, [...(_cache[51] || (_cache[51] = [
                    _createElementVNode("td", { colspan: "10" }, [
                      _createElementVNode("div", {
                        class: "tb_subject",
                        style: {"text-align":"center","width":"100%"}
                      }, "데이터가 없습니다.")
                    ], -1)
                  ]))]))
            ])
          ])
        ]),
        ($setup.state.list.length !== 0)
          ? (_openBlock(), _createBlock(_component_PageBtn, {
              key: 0,
              currentPage: $setup.state.page,
              totalLength: $setup.state.totalLength,
              perPage: $setup.state.size,
              data: $setup.state.data,
              onOnPaging: $setup.handlePageChange
            }, null, 8, ["currentPage", "totalLength", "perPage", "data", "onOnPaging"]))
          : _createCommentVNode("", true)
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true),
    ($setup.state.isReportShowModal)
      ? (_openBlock(), _createBlock(_component_ReportModal, {
          key: 1,
          reportInfo: $setup.state.reportInfo,
          nextInfo: $setup.state.nextReport,
          prevInfo: $setup.state.prevReport,
          onClose: _cache[31] || (_cache[31] = ($event: any) => ($setup.state.isReportShowModal = false)),
          onSave: $setup.save,
          onNext: _cache[32] || (_cache[32] = ($event: any) => ($setup.nextReport())),
          onPrev: _cache[33] || (_cache[33] = ($event: any) => ($setup.prevReport()))
        }, null, 8, ["reportInfo", "nextInfo", "prevInfo", "onSave"]))
      : _createCommentVNode("", true)
  ], 64))
}